import { render, staticRenderFns } from "./Reactive.vue?vue&type=template&id=a23bdff0&scoped=true&"
import script from "./Reactive.vue?vue&type=script&lang=js&"
export * from "./Reactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23bdff0",
  null
  
)

export default component.exports